<template>
  <div class="stat-filter">
    <button
      type="button"
      class="stat-filter__chip"
      :class="{ 'stat-filter__chip--active': !value.length }"
      @click="$emit('input', [])"
    >
      Alle Shops
    </button>
    <button
      v-for="shop in shops"
      :key="shop.shopCode"
      type="button"
      class="stat-filter__chip"
      :class="{ 'stat-filter__chip--active': value.includes(shop.shopCode) }"
      @click="toggle(shop.shopCode)"
    >
      <span class="stat-filter__dot" :style="{ background: shopColor(shop.shopCode) }" />
      {{ shop.domain }}
    </button>
    <span v-if="value.length" class="stat-filter__hint">
      KI-/Zusatzkosten sind nicht Shop-gebunden und bleiben bei aktivem Filter außen vor
    </span>
  </div>
</template>

<script>
import { statisticsColors } from "@/config";

export default {
  name: "StatisticsFilterBar",
  props: {
    shops: { type: Array, default: () => [] },
    value: { type: Array, default: () => [] },
  },
  methods: {
    shopColor(shopCode) {
      return statisticsColors[shopCode] || "#9ca3af";
    },
    toggle(shopCode) {
      const next = this.value.includes(shopCode)
        ? this.value.filter((code) => code !== shopCode)
        : [...this.value, shopCode];
      this.$emit("input", next);
    },
  },
};
</script>

<style lang="scss" scoped>
.stat-filter {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  margin-bottom: 12px;

  @media (max-width: 700px) {
    flex-wrap: nowrap;
    overflow-x: auto;
    padding-bottom: 4px;
    -webkit-overflow-scrolling: touch;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  &__chip {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    white-space: nowrap;
    flex-shrink: 0;
    border: 1px solid rgba(0, 0, 0, 0.1);
    background: #fff;
    border-radius: 999px;
    font-size: 12.5px;
    font-weight: 600;
    padding: 4px 13px;
    cursor: pointer;
    color: rgba(0, 0, 0, 0.6);
    transition: all 0.15s ease;

    &--active {
      background: #1f2937;
      border-color: #1f2937;
      color: #fff;
    }
  }

  &__dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    flex-shrink: 0;
  }

  &__hint {
    font-size: 11px;
    color: rgba(0, 0, 0, 0.4);
  }
}
</style>
